/* SPH – Dachhaut Wunschmass-Konfigurator (nur Dachhaut-Produkte) */
(function () {
  var root = document.querySelector('[data-sph-product]');
  if (!root) return;
  var h1 = root.querySelector('h1');
  if (!h1 || h1.textContent.indexOf('Dachhaut') === -1) return;
  var form = document.getElementById('sph-buy-form');
  var buyRow = root.querySelector('.sph-buy');
  if (!form || !buyRow) return;
  /* Standard-Zuschnitt (Stegplatten-Logik) auf Dachhaut-Seiten ausblenden */
  var oldCut = root.querySelector('[data-sph-cut]');
  if (oldCut) oldCut.style.display = 'none';

  var wrap = document.createElement('details');
  wrap.className = 'sph-cut sph-dach';
  wrap.innerHTML =
    '<summary class="sph-cut__sum">' +
      '<span class="sph-cut__t"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="color:var(--sph-red)"><path d="M3 17 17 3l4 4L7 21H3v-4z"/><path d="m8 8 2 2M11 5l2 2M14 2l2 2"/></svg> Dachhaut Wunschmass</span>' +
      '<span class="sph-cut__right"><span class="sph-cut__free">kostenfrei</span><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m9 6 6 6-6 6"/></svg></span>' +
    '</summary>' +
    '<div class="sph-cut__in">' +
      '<p class="sph-cut__note">Wählen Sie Ihr exaktes Dachmass — wir schneiden Platten und Set passend zu. <b>Als Basis wählen Sie oben die nächstgrössere Breite und Tiefe.</b></p>' +
      '<div class="sph-dach__grp"><span class="sph-dach__l">Befestigung / Auswahl der Schrauben</span>' +
        '<div class="sph-dach__radios">' +
          '<label class="sph-dach__rad"><input type="radio" name="sph-dach-schraube" value="Auf Holz" checked><span>Auf Holz</span></label>' +
          '<label class="sph-dach__rad"><input type="radio" name="sph-dach-schraube" value="Auf Stahl/Aluminium"><span>Auf Stahl/Aluminium</span></label>' +
        '</div></div>' +
      '<div class="sph-dach__grp"><span class="sph-dach__l">Individuelle Dachbreite</span>' +
        '<span class="sph-dach__inp"><input type="number" inputmode="numeric" data-sph-dach="breite" placeholder="Dachbreite in mm" min="1000" step="10"><em>mm</em></span></div>' +
      '<div class="sph-dach__grp"><span class="sph-dach__l">Individuelle Dachtiefe</span>' +
        '<span class="sph-dach__inp"><input type="number" inputmode="numeric" data-sph-dach="tiefe" placeholder="Dachtiefe in mm" min="1000" step="10"><em>mm</em></span></div>' +
      '<div class="sph-dach__grp"><span class="sph-dach__l">Symmetrie der Platten</span>' +
        '<div class="sph-dach__radios">' +
          '<label class="sph-dach__rad"><input type="radio" name="sph-dach-sym" value="Alle Platten in der Breite zuschneiden" checked><span>Alle Platten in der Breite zuschneiden</span></label>' +
          '<label class="sph-dach__rad"><input type="radio" name="sph-dach-sym" value="1 Platte in der Breite zuschneiden"><span>1 Platte in der Breite zuschneiden</span></label>' +
          '<label class="sph-dach__rad"><input type="radio" name="sph-dach-sym" value="2 Platten in der Breite zuschneiden"><span>2 Platten in der Breite zuschneiden</span></label>' +
        '</div></div>' +
      '<div class="sph-dach__sum" data-sph-dachsum hidden></div>' +
      '<div class="sph-dach__info"><b>ℹ</b><span>Stegplatten schneiden wir in der Breite und in der Länge zu. Aluminium-Profile können bauseits ganz einfach gekürzt werden.</span></div>' +
      '<div class="sph-dach__info sph-dach__info--warn"><b>!</b><span>Zugeschnittene Produkte sind von der Rückgabe ausgeschlossen.</span></div>' +
    '</div>';
  buyRow.parentNode.insertBefore(wrap, buyRow);

  function val(k) { var i = wrap.querySelector('[data-sph-dach="' + k + '"]'); return i && i.value ? parseInt(i.value, 10) || 0 : 0; }
  function rad(n) { var r = wrap.querySelector('input[name="' + n + '"]:checked'); return r ? r.value : ''; }

  var sum = wrap.querySelector('[data-sph-dachsum]');
  function refresh() {
    var b = val('breite'), t = val('tiefe');
    if (b || t) {
      sum.hidden = false;
      sum.innerHTML = 'Ihr Wunschmass: <b>' + (b ? b + ' mm breit' : '–') + (t ? ' × ' + t + ' mm tief' : '') + '</b> · ' + rad('sph-dach-schraube') + ' · ' + rad('sph-dach-sym');
    } else { sum.hidden = true; }
    /* properties am Formular pflegen */
    ['Befestigung', 'Wunsch-Dachbreite', 'Wunsch-Dachtiefe', 'Symmetrie'].forEach(function (k) {
      var el = form.querySelector('input[name="properties[' + k + ']"]');
      if (el) el.remove();
    });
    function addProp(k, v) {
      if (!v) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = v;
      form.appendChild(i);
    }
    addProp('Befestigung', rad('sph-dach-schraube'));
    if (b) addProp('Wunsch-Dachbreite', b + ' mm');
    if (t) addProp('Wunsch-Dachtiefe', t + ' mm');
    if (b || t) addProp('Symmetrie', rad('sph-dach-sym'));
  }
  wrap.addEventListener('input', refresh);
  wrap.addEventListener('change', refresh);
  refresh();
})();
